import styled from 'styled-components'

export default styled.label`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 600;
  font-size: 14px;
`



// WEBPACK FOOTER //
// ./src/components/elements/label/index.js